/**
 * Mirrors DB job analytics rows. Map API snake_case to these camelCase fields when wiring the API.
 */
export type JobAnalyticsEventName =
  | "VIEW_POSITION"
  | "FAVORITE"
  | "COMPARE_POSITION";

export type JobAnalyticsRow = {
  id: number;
  userId: string;
  eventName: JobAnalyticsEventName;
  /** Role the TM is currently in */
  currentPos: string | null;
  /** Compare: first role in the comparison */
  sourcePos: string | null;
  /** View / favorite: role of interest; compare: second role in the comparison */
  targetPos: string | null;
  appVersion: string | null;
  metadata: unknown;
  createdAt: string;
  currentPosId: string | null;
  sourcePosId: string | null;
  targetPosId: string | null;
};

export const EVENT_NAME_LABEL: Record<JobAnalyticsEventName, string> = {
  VIEW_POSITION: "View",
  FAVORITE: "Favorite",
  COMPARE_POSITION: "Compare",
};

/** Weighted interest per event (compare credits both source and target roles) */
export const INTEREST_WEIGHT: Record<JobAnalyticsEventName, number> = {
  VIEW_POSITION: 1,
  FAVORITE: 3,
  COMPARE_POSITION: 2,
};
